export default __webpack_public_path__ + "static/media/Inner-view-of-Jahangir-Mahal-Orchha.2634dbb4.jpg";